import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify } from "react-admin";
import { useLocation, useNavigate, useParams } from "react-router";
import { GraduationServicePath, STATE_EXAMS } from "utils/constants";
import CreateForm from "./CreateForm";

const CreateStateExamsResults = () => {
  const notify = useNotify();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const students = location?.state?.students || [];

  const transform = data => ({
    results: data.results.map(r => ({
      grade: r.grade,
      points: r.points,
      status: r.status,
      studentEducationId: r.studentEducationId,
    })),
  });

  const onSuccess = () => {
    notify("Успешно добавяне на резултати за държавен изпит", { type: "success" });
    navigate(-1);
  };
  return (
    <>
      <Create
        resource={`${GraduationServicePath}${STATE_EXAMS}/${id}/results`}
        title="Добави резултати за държавен изпит"
        actions={<BackButtonToolbar />}
        mutationOptions={{ onSuccess }}
        transform={transform}
      >
        <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
          <CreateForm students={students} />
        </SimpleForm>
      </Create>
    </>
  );
};

export default CreateStateExamsResults;
